import { API } from 'aws-amplify';
import { getTrainee } from '../graphql/queries';

export async function getTraineeVersion(id: string): Promise<number> {
  const { data }: any = await API.graphql({
    query: getTrainee,
    variables: { id },
    authMode: 'AWS_IAM',
  });

  if (!data.getTrainee) throw new Error('Trainee not found or not readable');
  return data.getTrainee._version;
}

export async function fetchTrainee(id: string) {
  const { data }: any = await API.graphql({
    query: getTrainee,
    variables: { id },
    authMode: 'AWS_IAM',
  });
  return data.getTrainee; // may be null
}
